export default __webpack_public_path__ + "static/media/contact.40cf425e.svg";